import React, { useState, useEffect } from "react";
import "../../App.css";


// Navbar component
function Navbar({ handleNavClick, activePage }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  // Handle responsive layout
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
      if (window.innerWidth >= 768) {
        setMenuOpen(false);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const mainNavSections = [
    { name: "Home", page: "home" },
    { name: "About Us", page: "aboutus", description: "Learn about our company and mission" },
    { name: "Products", page: "products-landing" },
    { name: "Industries", page: "services-landing" },
    { name: "Accolades", page: "events-awards" },
    { name: "Clients", page: "clients", description: "Discover our global client portfolio" },
    { name: "Contact Us", page: "contactus", description: "Get in touch with our experts" },
    { name: "Login", page: "login", description: "Access your account", isExternal: true, url: "http://pulse.geotechgeospatial.com/" },
  ];



  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [menuOpen]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleMenuItemClick = (item) => {
    // Close the menu first
    setMenuOpen(false);

    // Handle external links
    if (item.isExternal && item.url) {
      window.open(item.url, '_blank', 'noopener,noreferrer');
      return;
    }

    // Then navigate after a small delay for internal pages
    setTimeout(() => {
      handleNavClick(item.page);
    }, 300);
  };

  return (
    <>
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="navbar__container">
          {/* Menu Button */}
          <div className="menu__wrapper">
            <button
              className="menu__button"
              onClick={toggleMenu}
              aria-label="Toggle menu"
            >
              <span className="menu__text">Menu</span>
              <div className="menu__icon">
                <span className="menu__line"></span>
                <span className="menu__line"></span>
                <span className="menu__line"></span>
              </div>
            </button>
          </div>

          {/* Logo + Brand */}
          <div className="navbar__logo" onClick={() => handleNavClick('home')}>
            <img src="/logo.jpg" alt="GEOTECH Logo" className="logo" />
            <h1 className="navbar__brand">
              <span className="brand__green">GEOTECH </span>
            </h1>
          </div>

          {/* Main Navigation Menu - Only shown on desktop */}
          <div className="navbar__nav">
            {mainNavSections.map((section) => (
                <button
                  key={section.page}
                  className={`nav__item ${activePage === section.page ? "active" : ""}`}
                  onClick={() => handleMenuItemClick(section)}
                >
                  {section.name}
                </button>
              ))}
             
          </div>
        </div>
      </nav>

      {/* Airbus-Style Side Menu Overlay */}
      <div className={`menu__overlay ${menuOpen ? 'active' : ''}`} onClick={(e) => e.target === e.currentTarget && setMenuOpen(false)}>
        <div className="menu__sidebar">
          <div className="menu__sidebar-header">
            <div className="menu__sidebar-logo">
              <img src="/logo.jpg" alt="GEOTECH Logo" />
              <div className="menu__sidebar-brand">
                <span className="menu__sidebar-green">GEOTECH </span>
              </div>
            </div>
            <button
              className="menu__sidebar-close"
              onClick={() => setMenuOpen(false)}
              aria-label="Close menu"
            >
              ×
            </button>
          </div>

          <nav className="menu__sidebar-nav">
            {/* Main navigation items - only shown in mobile */}
            <div className="menu__sidebar-main-nav">
              <div className="menu__sidebar-section">
                {mainNavSections.map((section) => (
                  <button
                    key={section.page}
                    className="menu__sidebar-item menu__sidebar-item--main-nav"
                    onClick={() => handleMenuItemClick(section)}
                  >
                    <span className="menu__sidebar-item-text">{section.name}</span>
                    <svg className="menu__sidebar-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M6 4L10 8L6 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                ))}
              </div>
            </div>
            
            {/* Divider - only shown in mobile 
            {secondaryNavItems.length > 0 && <div className="menu__sidebar-divider"></div>}*/}
            
            {/* Secondary navigation items 
            <div className="menu__sidebar-secondary-nav">
              {secondaryNavItems.map((item) => (
                <button
                  key={item.page}
                  className={`menu__sidebar-item ${item.isHighlighted ? 'menu__sidebar-item--highlighted' : ''} ${item.isExternal ? 'menu__sidebar-item--external' : ''}`}
                  onClick={() => handleMenuItemClick(item)}
                >
                  <span className="menu__sidebar-item-text">{item.name}</span>
                  <svg className="menu__sidebar-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M6 4L10 8L6 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
              ))}
            </div>*/}
          </nav>
          <div className="menu__sidebar-footer">
            <div className="menu__sidebar-cta">
              <h4>Get Started</h4>
              <p>Explore our comprehensive geospatial solutions</p>
              <button
                className="menu__sidebar-btn"
                onClick={() => handleMenuItemClick({ page: 'products-landing' })}
              >
                Learn More
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}


export default Navbar;